/* WebComponentFloatButton template */
import { FunctionalComponent, h, Host } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { FloatButtonComponent } from './cwc-float-button';

/**
 * Definition of  parameters that the template needs to work.
 */
interface FloatButtonTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: FloatButtonComponent;

  // Specify parameters that are required to be passed down to the template here.
}

const FloatButtonTemplate: FunctionalComponent<FloatButtonTemplateProps> = () => (
  <Host>
    <slot></slot>
  </Host>
);

export default FloatButtonTemplate;
